import { render, staticRenderFns } from "./OperationMaintenanceRecord.vue?vue&type=template&id=9b60c046&scoped=true"
import script from "./OperationMaintenanceRecord.vue?vue&type=script&lang=js"
export * from "./OperationMaintenanceRecord.vue?vue&type=script&lang=js"
import style0 from "./OperationMaintenanceRecord.vue?vue&type=style&index=0&id=9b60c046&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b60c046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b60c046')) {
      api.createRecord('9b60c046', component.options)
    } else {
      api.reload('9b60c046', component.options)
    }
    module.hot.accept("./OperationMaintenanceRecord.vue?vue&type=template&id=9b60c046&scoped=true", function () {
      api.rerender('9b60c046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/OperationMaintenanceRecord/OperationMaintenanceRecord.vue"
export default component.exports